//=================== review_video_left

var swiperreviewvideo = new Swiper(".review_video_left", {
  slidesPerView: "auto",
  spaceBetween: 16,
  centeredSlides: true,
  navigation: {
    nextEl: ".review_video_row .swiper-button-next",
    prevEl: ".review_video_row .swiper-button-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: "auto",
      spaceBetween: 16,
      centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      loop: true,
    },
    576: {
      slidesPerView: "auto",
      spaceBetween: 16,
      centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      loop: true,
    },
    768: {
      slidesPerView: "auto",
      spaceBetween: 16,
      centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      loop: true,
    },
    992: {
      slidesPerView: "auto",
      spaceBetween: 24,
      centeredSlides: false,
      slidesOffsetAfter: 80,
    },
    1200: {
      slidesPerView: "auto",
      spaceBetween: 24,
      centeredSlides: false,
      slidesOffsetAfter: 80,
    },
    1441: {
      slidesPerView: "auto",
      spaceBetween: 24,
      centeredSlides: false,
      slidesOffsetAfter: 80,
    },
  },
});

// ============================ Control autoplay on hover for desktop

var swiperElement = document.querySelector(".review_video_left");
  swiperElement.addEventListener("mouseenter", function () {
    swiper3_watch_and_shopSwiper.autoplay.stop();
  });
  swiperElement.addEventListener("mouseleave", function () {
    swiper3_watch_and_shopSwiper.autoplay.start();
  });

  // Remove the initial autoplay handling for videos

  // Function to handle video autoplay on hover
  $(".review_video_left video").hover(
    function () {
      $(this).get(0).play();
    },
    function () {
      $(this).get(0).pause();
    }
  );

// ========================= Video autoplay control based on device type

$(function () {
  $(".review_video_left video").prop("volume", 0.0);
  function isMobileOrTablet() {
    return /Mobi|Android|iPhone|iPad|iPod|Tablet/i.test(navigator.userAgent);
  }
  if (isMobileOrTablet()) {
    // For mobile devices and tablets: play video on hover only
    $(".review_video_left video").hover(
      function () {
        $(this).get(0).play();
      },
      function () {
        $(this).get(0).pause();
      }
    );
  }
});
